export const isPromise = (obj: any) => {
  return !!obj && 'then' in obj && typeof obj.then === 'function';
};
